import {
  FDAvatar, FDBox,
  FDDialog, FDDialogActions,
  FDDialogContent,
  FDHeadlineText,
  FDLabelText, FDPrimaryActionButton,
  FDStack,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import React from 'react';
import fr from 'facet-rest';
import RichTextDisplay from 'Components/UI/RichTextDisplay';
import { dataAttrs } from 'Helpers/Testing';
import useMobileLayout from 'Hooks/useMobileLayout';
import { useRightColumnContext } from 'Context/RightColumnContext';

const ProposalCFPInsightDialog = ({
  insightResource, isOpen, onClose, showMessageButton,
}) => {
  const { loadRightColumnCollectionLink, rightColumnCollectionLoading } = useRightColumnContext();
  const insightContent = insightResource.attr('cfpCustomInsightContent');
  const isMobile = useMobileLayout();
  const plannerProfileImageRel = insightResource.withRelationship(fr.relationships.plannerProfileImage.name,
    (rel) => rel,
    () => null);
  const messagePlannerFromCustomInsightRel = insightResource.withRelationship(fr.relationships.messagePlannerFromCustomInsight.name,
    (rel) => rel,
    () => null);

  return (
    <FDDialog
      open={isOpen}
      onClose={onClose}
      closeOnBackdropClick
      dialogWidth={'md'}
      color={'subtle'}
      {...dataAttrs('proposal-cfp-insight-dialog')}
    >
      <FDDialogContent>
        <FDStack direction={'column'} spacing={4}>
          <FDStack direction={'column'} spacing={1} alignItems={'center'}>
            <FDAvatar alt={plannerProfileImageRel?.meta('altText')} src={plannerProfileImageRel?.link('related').url()} size={'lg'} />
            <FDLabelText size={'lg'} value={insightResource.attr('cfpCustomInsightPlannerDisplayName')} color={'textSecondary'} />
            <FDHeadlineText size={'sm'} value={insightResource.attr('cfpCustomInsightTitle')} />
          </FDStack>
          <FDBox paddingX={isMobile ? 1 : 8}>
            <RichTextDisplay content={insightContent} />
          </FDBox>
          <FDBox alignSelf={'center'}>
            {showMessageButton
              ? <FDPrimaryActionButton
                disabled={!!messagePlannerFromCustomInsightRel.meta('disabled')}
                label={messagePlannerFromCustomInsightRel.meta('prompt')}
                loading={rightColumnCollectionLoading ?? false}
                onClick={() => {
                  loadRightColumnCollectionLink(messagePlannerFromCustomInsightRel.link('related'));
                  onClose();
                }}
                {...dataAttrs('cfp-insight-message-planner-button')}
              /> : null}
          </FDBox>
        </FDStack>
      </FDDialogContent>
      <FDDialogActions>
        <FDStack width={'100%'} justifyContent={'flex-end'}>
          <FDPrimaryActionButton
            label="Close"
            onClick={onClose}
            {...dataAttrs('close-custom-insight-dialog')}
          />
        </FDStack>
      </FDDialogActions>
    </FDDialog>
  );
};

ProposalCFPInsightDialog.defaultProps = {
};

ProposalCFPInsightDialog.propTypes = {
  insightResource: PropTypes.object.isRequired,
  isOpen: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  showMessageButton: PropTypes.bool.isRequired,
};

export default ProposalCFPInsightDialog;
